(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('module-tr', {
            parent: 'entity',
            url: '/module-tr?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.module_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/module-tr/module-trs.html',
                    controller: 'Module_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('module_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('module-tr-detail', {
            parent: 'module-tr',
            url: '/module-tr/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.module_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/module-tr/module-tr-detail.html',
                    controller: 'Module_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('module_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Module_tr', function($stateParams, Module_tr) {
                    return Module_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'module-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('module-tr-detail.edit', {
            parent: 'module-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-dialog.html',
                    controller: 'Module_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Module_tr', function(Module_tr) {
                            return Module_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('module-tr.new', {
            parent: 'registryEntities',
            url: '/module-tr/{id}/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Module', function($stateParams, $state, $uibModal,Module) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-dialog.html',
                    controller: 'Module_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null,
                                module: Module.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('module-tr.edit', {
            parent: 'registryEntities',
            url: '/module-tr/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-dialog.html',
                    controller: 'Module_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Module_tr', function(Module_tr) {
                            return Module_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('module-tr', null, { reload: 'module-tr' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('module-tr.delete', {
            parent: 'registryEntities',
            url: '/module-tr/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/module-tr/module-tr-delete-dialog.html',
                    controller: 'Module_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Module_tr', function(Module_tr) {
                            return Module_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
